import { FC } from "react"
import { Mail } from "lucide-react"

import { STATS_PALETTE } from "../../../../../stats/theme"

interface NameCellProps {
  info: string
  colSpan?: number
}

const NameCell: FC<NameCellProps> = ({ info, colSpan = 1 }) => (
  <td className="whitespace-nowrap h-16 p-0" colSpan={colSpan}>
    <div className="flex items-center gap-2.5 px-3 text-sm font-medium leading-6 text-ellipsis overflow-hidden">
      <span
        className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full"
        style={{ backgroundColor: `${STATS_PALETTE[0]}1A` }}
      >
        <Mail size={14} color={STATS_PALETTE[0]} />
      </span>
      <span className="truncate">{info}</span>
    </div>
  </td>
)

export default NameCell
